export default import.meta.ROLLUP_FILE_URL_vXuvxjtzQrX9G55xXoL3_A